export const TRANSLATIONS_FR_PLANS_AND_ADMIN = {
  "usage.period.month": "ce mois-ci",
  "usage.hero.title": "Consommation clé de la période",
  "usage.hero.used": "utilisé",
  "usage.hero.no_data": "Pas encore de données",
  "admin.title": "Administration",
  "admin.members": "Membres",
  "admin.invite": "Inviter",
  "admin.pending": "Invitations en attente",
  "admin.roles": "Rôles",
  "admin.settings.title": "Administration",
  "admin.settings.organizationName": "Nom de l'organisation",
  "admin.settings.inviteExpiryDays": "Jours d'expiration des invitations (1-60)",
  "admin.settings.allowedDomains": "Domaines autorisés (séparés par virgule ou ligne)",
  "admin.settings.defaultRole": "Rôle par défaut",
  "admin.settings.locale": "Paramètres régionaux",
  "admin.members.title": "Membres de l'organisation",
  "admin.invite.title": "Inviter un utilisateur",
  "admin.invite.send": "Envoyer l'invitation",
  "admin.invite.invitations": "Invitations",
  "admin.invite.resend": "Renvoyer l'invitation",
  "admin.invite.revoke": "Révoquer l'invitation",
  "admin.invite.empty": "Aucune invitation à afficher.",
  "admin.roles.title": "Rôles et permissions",
  "admin.roles.permissions": "Permissions",
  "admin.roles.delete": "Supprimer le rôle",
};
